import { List } from 'immutable';
import { Locations } from 'records/Location';
import BaseList from 'records/BaseList';

import {
  LOCATIONS_ASYNC_ACTION_START,
  LOCATIONS_ASYNC_ACTION_ERROR,
  LOCATIONS_ASYNC_UPDATE_SUCCESS,
  LOCATIONS_RESET_STATE,
} from 'actions/locations';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [LOCATIONS_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [LOCATIONS_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [LOCATIONS_ASYNC_UPDATE_SUCCESS]: (state, action) => {
    const locationsData = Locations(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: locationsData,
    });
  },
  [LOCATIONS_RESET_STATE]: () => {
    return initialState;
  },
};

export default function locations(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
